export default __webpack_public_path__ + "703de8791abba704c010970438bc6002.mp3";